import {InjectionToken} from '@angular/core';

export const MQTT_MOCK = new InjectionToken('mqtt mock');
